<script>
  import { setContext, getContext } from 'svelte'
  import FormHandler from './builder.js'

  export let layout = null
  export let config = {}
  export let validationMode = 'default'
  export let id = null

  setContext(
    'currentForm',
    FormHandler({
      validationMode
    })
  )

  const FormTheme = getContext('FormTheme')
  const elementName = 'Form'

  if (layout) setContext('formGroupLayout', layout)
</script>

{#if layout && FormTheme[`${layout}${elementName}`]}
  <svelte:component this={FormTheme[`${layout}${elementName}`]} {config}>
    <slot name="header" slot="header" />
    <slot />
    <slot name="footer" slot="footer" />
  </svelte:component>
{:else if FormTheme[elementName]}
  <svelte:component this={FormTheme[elementName]} {config}>
    <slot name="header" slot="header" />
    <slot />
    <slot name="footer" slot="footer" />
  </svelte:component>
{:else}
  <form
    {id}
    on:submit={e => {
      e.preventDefault()
    }}
  >
    <slot name="header" />
    <slot />
    <slot name="footer" />
  </form>
{/if}
